import type { DeskOpenPoRow, DeskOpenSoRow } from "@icraftx/shared/v1";
import { apiGet } from "./client";

export type SyncParty = {
  id: string;
  code: string | null;
  name: string;
  isCustomer: boolean;
  isSupplier: boolean;
  priceListId: string | null;
  deleted: boolean;
  updatedAt: string;
};

export type SyncPayMethod = {
  id: string;
  code: string;
  name: string;
  isDefault: boolean;
  worksOffline: boolean;
  glAccountCode: string;
  deleted: boolean;
  updatedAt: string;
};

export function pullParties(
  companyRef: string,
  opts?: { since?: string; sinceId?: string },
) {
  const q = new URLSearchParams();
  if (opts?.since) q.set("since", opts.since);
  if (opts?.sinceId) q.set("sinceId", opts.sinceId);
  const qs = q.toString();
  return apiGet<{
    channel: string;
    data: SyncParty[];
    lastUpdated: string | null;
    lastId: string | null;
  }>(`/c/${companyRef}/sync/parties${qs ? `?${qs}` : ""}`);
}

export function pullPayMethodsSync(
  companyRef: string,
  opts?: { since?: string; sinceId?: string },
) {
  const q = new URLSearchParams();
  if (opts?.since) q.set("since", opts.since);
  if (opts?.sinceId) q.set("sinceId", opts.sinceId);
  const qs = q.toString();
  return apiGet<{
    channel: string;
    data: SyncPayMethod[];
    lastUpdated: string | null;
    lastId: string | null;
  }>(`/c/${companyRef}/sync/pay-methods${qs ? `?${qs}` : ""}`);
}

export function pullOrgDefaults(companyRef: string) {
  return apiGet<{
    channel: string;
    data: {
      taxPriceMode: string;
      taxRatePct: string;
      discountSoftCapPct: number;
      allowOversell?: boolean;
      currencyCode: string;
      timezone: string;
    };
    lastUpdated: string | null;
  }>(`/c/${companyRef}/sync/org-defaults`);
}

export type DeskOpenPage<T> = {
  data: T[];
  lastUpdated: string | null;
  lastId: string | null;
};

export function pullDeskOpen(
  companyRef: string,
  opts?: {
    soSince?: string;
    soSinceId?: string;
    poSince?: string;
    poSinceId?: string;
    signal?: AbortSignal;
  },
) {
  const q = new URLSearchParams();
  if (opts?.soSince) q.set("soSince", opts.soSince);
  if (opts?.soSinceId) q.set("soSinceId", opts.soSinceId);
  if (opts?.poSince) q.set("poSince", opts.poSince);
  if (opts?.poSinceId) q.set("poSinceId", opts.poSinceId);
  const qs = q.toString();
  return apiGet<{
    channel: string;
    salesOrders: DeskOpenPage<DeskOpenSoRow>;
    purchaseOrders: DeskOpenPage<DeskOpenPoRow>;
  }>(`/c/${companyRef}/sync/desk-open${qs ? `?${qs}` : ""}`, {
    signal: opts?.signal,
  });
}
